<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cell-click="chooseRow"
            :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button v-auth="'ACTIVATION'" @click="changeStatus(1)">激活</vxe-button>
        <vxe-button v-auth="'HANGUP'" @click="changeStatus(0)">挂起</vxe-button>
      </template>
    </x-grid>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData} from "@/services/baseCodeSource";
import {dataApi} from "@/services/workflow/doingWorkflow";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

const fac = XGrid.factory;

//列表接口
const url = api.workflow.WORK_FLOW_MANAGE + '/running';

//主键
const rowId = 'id';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("processInstanceId", "id", 100),
  fac.makeColumn("processDefinitionId", "流程定义ID", 140),
  fac.makeColumn("processDefinitionKey", "流程定义标识", 160),
  fac.makeColumn("processDefinitionName", "流程定义名称", 160),
  fac.makeColumn("activityId", "当前运行节点", 160),
  // fac.makeColumn("suspended", "状态", 160),
]

let formConfig = fac.makeFormConfig(columns, [
  {field: 'processInstanceId'},
  {field: 'processDefinitionKey'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  delData: false,
  import: false,
  export: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  components: {},
  // authorize: {
  //   addRow: "ADD",
  //   updateRow: 'UPDATE',
  //   delRow: 'DELETE',
  // },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,

    }
  },
  methods: {
    async changeStatus(status) {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      await dataApi.changeStatus(rows[0][this.rowId], status);
      this.refresh();
    },
  }
}
</script>

<style scoped>
</style>